
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/simulacao/orcamento/finalizado",
      function () {
        return require("private-next-pages/simulacao/orcamento/finalizado/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/simulacao/orcamento/finalizado"])
      });
    }
  